var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPools = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 31,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  fillRule: "evenodd",
  d: "M6.163 21.275c0-2.26 5.137-4.09 11.475-4.09 6.339 0 11.477 1.83 11.477 4.09v3.758c0 2.26-5.138 4.09-11.477 4.09-6.338 0-11.475-1.83-11.475-4.09z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#FECD3D",
  fillRule: "evenodd",
  d: "M17.638 17.184c6.339 0 11.477 1.83 11.477 4.09s-5.138 4.091-11.477 4.091c-6.338 0-11.475-1.832-11.475-4.09 0-2.26 5.137-4.09 11.475-4.09",
  clipRule: "evenodd"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#DC2626",
  fillRule: "evenodd",
  d: "M17.638 17.184c1.93 0 3.748.17 5.343.469v.271c0 2.26-5.138 4.09-11.475 4.09-1.919 0-3.727-.167-5.317-.463a1.5 1.5 0 0 1-.026-.276c0-2.26 5.137-4.09 11.475-4.09",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  fillRule: "evenodd",
  d: "M17.638 19.095c5.043 0 9.13.976 9.13 2.18 0 1.203-4.087 2.178-9.13 2.178-5.041 0-9.13-.975-9.13-2.178 0-1.204 4.089-2.18 9.13-2.18",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#CE8829",
  fillRule: "evenodd",
  d: "M17.638 19.095c1.67 0 3.237.107 4.585.295-1.655 1.535-5.829 2.624-10.717 2.624-.896 0-1.767-.036-2.604-.105-.256-.201-.394-.415-.394-.634 0-1.204 4.089-2.18 9.13-2.18",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fill: "#C85929",
  d: "M26.012 25.829v2q.53-.2.981-.427v-1.575zm-2.565 2.732q-.477.1-.98.184v-1.907l.98.001zm-3.546.482q-.483.034-.98.055v-1.82l.98.003zm-3.544.055q-.5-.02-.982-.055v-1.764h.982zm-3.547-.353a25 25 0 0 1-.98-.184v-1.724l.98.002zm-3.545-.916a10 10 0 0 1-.982-.427v-1.573l.982-.002z"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  fillRule: "evenodd",
  d: "M.03 13.185c0-2.26 5.138-4.092 11.476-4.092 6.337 0 11.475 1.832 11.475 4.092v3.758c0 2.258-5.138 4.09-11.475 4.09-6.338 0-11.477-1.832-11.477-4.09z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fill: "#FECD3D",
  fillRule: "evenodd",
  d: "M11.506 9.093c6.337 0 11.475 1.832 11.475 4.092 0 2.258-5.138 4.09-11.475 4.09-6.338 0-11.477-1.832-11.477-4.09 0-2.26 5.139-4.092 11.477-4.092",
  clipRule: "evenodd"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#CEA732",
  fillRule: "evenodd",
  d: "M11.506 9.093c6.337 0 11.475 1.832 11.475 4.092q-.001.332-.146.653a34 34 0 0 1-3.845.21c-6.996 0-12.668-2.02-12.668-4.514a29.5 29.5 0 0 1 5.184-.441",
  clipRule: "evenodd"
})), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  fillRule: "evenodd",
  d: "M11.506 11.005c5.041 0 9.13.976 9.13 2.18 0 1.203-4.089 2.178-9.13 2.178-5.043 0-9.13-.975-9.13-2.178s4.087-2.18 9.13-2.18",
  clipRule: "evenodd"
})), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
  fill: "#CE8829",
  fillRule: "evenodd",
  d: "M11.506 11.005c5.041 0 9.13.976 9.13 2.18 0 .301-.259.591-.728.852q-.455.012-.918.012c-5.289 0-9.819-1.154-11.718-2.795a35 35 0 0 1 4.234-.25",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  fill: "#C85929",
  d: "M19.88 17.738v2q.53-.202.981-.427v-1.575zm-2.566 2.732a24 24 0 0 1-.98.184v-1.907l.98.002zm-3.546.482q-.482.035-.98.055v-1.82l.98.001zm-3.545.055q-.495-.02-.982-.055v-1.764l.982-.001zm-3.547-.353a25 25 0 0 1-.98-.184v-1.723l.98.002zm-3.543-.915a11 11 0 0 1-.984-.428v-1.573l.984-.002z"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  d: "M29.091 13.827v.881h.88v.842h-.88v.88h-.842v-.88h-.88v-.842h.88v-.881zM2.7 22.765v.88h.88v.841H2.7v.88h-.842v-.88h-.88v-.842h.88v-.88zM2.7 4.366v.88h.88v.842H2.7v.88h-.842v-.88H.977v-.842h.88v-.88z"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  fill: "#FE9923",
  fillRule: "evenodd",
  d: "M6.163 5.092c0-2.258 5.137-4.09 11.475-4.09 6.339 0 11.477 1.832 11.477 4.09v3.76c0 2.258-5.138 4.09-11.477 4.09-6.338 0-11.475-1.832-11.475-4.09z",
  clipRule: "evenodd"
})), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#FECD3D",
  fillRule: "evenodd",
  d: "M17.638 1.002c6.339 0 11.477 1.832 11.477 4.09 0 2.26-5.138 4.092-11.477 4.092-6.338 0-11.475-1.832-11.475-4.092 0-2.258 5.137-4.09 11.475-4.09",
  clipRule: "evenodd"
})), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#FEA832",
  fillRule: "evenodd",
  d: "M17.638 2.914c5.043 0 9.13.975 9.13 2.178 0 1.205-4.087 2.18-9.13 2.18-5.041 0-9.13-.975-9.13-2.18 0-1.203 4.089-2.178 9.13-2.178",
  clipRule: "evenodd"
})), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#C85929",
  d: "M26.012 9.648v2q.53-.202.981-.427V9.646zm-2.565 2.732q-.477.1-.98.182v-1.905l.98.002zm-3.546.482q-.483.034-.98.055v-1.82l.98.001zm-3.544.055a36 36 0 0 1-.982-.055v-1.764l.982-.001zm-3.547-.355a22 22 0 0 1-.98-.182v-1.723l.98.002zm-3.545-.913a11 11 0 0 1-.982-.428V9.648l.982-.002z"
})));
export default SvgPools;